  /* eslint-disable */
<template>

  <v-card
    class="mx-auto my-12"
    max-width="500"
  >

     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

    <v-card-title></v-card-title>

    <v-divider  class="mx-4"></v-divider>

    <v-card-title>{{instituicaodescricao}}-{{this.editedItem.anoLectivo}}</v-card-title>

    <v-card-text v-role="'func'">
      <v-chip-group

        active-class="deep-purple accent-4 white--text"
        column
      >
        <v-chip>{{this.editedItem.quantidade}} Alunos</v-chip>

      </v-chip-group>
    </v-card-text>
<v-col cols="12" sm="12" md="6">
                       <v-combobox
                        v-model="editedItem.lectivo"
                        item-value="descricao"
                        item-text="descricao"
                         @change="initInstituicao()"
                        :items="ano"
                        chips
                        label="Ano Lectivo"
                      ></v-combobox>
                    </v-col>
  </v-card>
</template>
<script>
// const message = require('../config/messages')
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    instituicao: [],
    ano: [],
    isLoading: true,
    editedItem: {
      lectivo: 0,
      quantidade: 0,
      anoLectivo: 0
    },
    defaultItem: {
      lectivo: 0,
      quantidade: 0,
      anoLectivo: 0
    }
  }),
  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlgêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  loggedUserName () {
    return ls.get('idPessoa')
  },
  created () {
    this.initInstituicao()
    this.initAnoLectivo()
  },

  methods: {
    async initInstituicao () {
      this.isLoading = true
      let a = ls.get('anolectivo')
      if (this.editedItem.lectivo === 0) { console.log('oi') } else {
        a = this.editedItem.lectivo.descricao
        console.log('Classe: ' + a)
      }

      try {
        this.instituicao = await axios
          .get('/quantidadeAlunosInstituicao/' + a)
          .then(res => res.data)
        this.isLoading = false
        console.log('Dados ' + this.instituicao[0].quantidade)
        this.editedItem.quantidade = this.instituicao[0].quantidade
        this.editedItem.anoLectivo = this.instituicao[0].anoLectivo
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initAnoLectivo () {
      console.log('oi')
      try {
        this.ano = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }

  }
}
</script>
